import { gql } from '@apollo/client/core'
import { ONLY_PLAYER_EVENT_FRAGMENT } from '../fragments/OnlyPlayerEvent'

export const CREATE_PLAYER_EVENT_MUTATION = gql`
  ${ONLY_PLAYER_EVENT_FRAGMENT}

  mutation createPlayerEvent($eventName: String!, $clubId: String!, $isNonGolf: Boolean!, $createdByPlayerId: String) {
    createEvent(name: $eventName, clubId: $clubId, isNonGolf: $isNonGolf, createdByPlayerId: $createdByPlayerId) {
      ... on CreateEventOutput {
        event {
          ...OnlyPlayerEvent
        }
      }
    }
  }
`
